// extracted by mini-css-extract-plugin
var _1 = "styles-module__closeButton___xmt4t";
var _2 = "styles-module__contentContainer____jaFI";
var _3 = "styles-module__popupContainer___HS7eZ";
var _4 = "styles-module__popupLocation___t3X4v";
export { _1 as "closeButton", _2 as "contentContainer", _3 as "popupContainer", _4 as "popupLocation" }
